import { Masks } from "./masks";

export class FiscalNumber {
  static isValid(value: string): boolean {
    if (!value) return false;
    value = value.trim().toUpperCase().replace(/[./-]/g, "");
    if (!/^[A-Z0-9]{14}$/.test(value)) return false;
    
    const first = value[0];
    const allSame = value.split('').every(char => char === first);
    return !allSame;
  }

  private readonly value: string;
  private readonly root: string;

  constructor(value: string) {
    const normalizedValue = value.trim().toUpperCase().replace(/[./-]/g, "");
    if (FiscalNumber.isValid(value)) {
      this.value = normalizedValue;
      this.root = this.value.substring(0, 8);
    } else {
      throw Error("CNPJ inválido");
    }
  }

  public getValue(): string {
    return this.value;
  }

  public getMaskedValue(): string {
    return Masks.fiscalNumberMask(this.value);
  }
}
